import { authAPIUrl } from "@/environment";
import { RoleService } from "@/services/role.service";
import { UserService } from "@/services/user.service";

import { catched } from "./catched";

export class UserHandler {
  constructor() {
    this.userService = new UserService(authAPIUrl);
    this.roleService = new RoleService(authAPIUrl);
  }

  createUser(email, name, role) {
    return this.userService.createUser(name, email, role); // not catched -> error is exposed via FeedbackButton
  }

  async getUsers(offset = 0) {
    const { data, ...pagination } = await this.userService.getUsers(offset);
    return catched(data, pagination);
  }

  async getUser(id) {
    return catched(this.userService.getUser(id));
  }

  getOrgEntitiesOfUser(id) {
    return catched(this.userService.getOrgEntities(id));
  }

  async getRoles() {
    const res = await catched(this.roleService.getRoles());
    if (!res.success) return res;
    return { data: res.data.results };
  }

  /**
   * Updates a user's information
   * @param {string} userId - The ID of the user to update
   *
   * @param {string} data.email - The user's email address
   * @param {string} data.name - The user's name
   * @param {string} data.role - The user's role
   * @param {string} data.preferredLanguage - The user's preferred language
   */
  updateUser(userId, data) {
    return this.userService.updateUser(userId, data); // not catched -> error is exposed via FeedbackButton
  }

  /**
   * Update the currently logged-in user (me)
   * @param {string} data.name - The user's name
   * @param {string} data.preferredLanguage - The user's preferred language
   */
  updateMe(data) {
    return catched(this.userService.updateMe(data));
  }

  deleteUser(id) {
    return catched(this.userService.deleteUser(id));
  }

  changePassword(userId, newPassword) {
    return catched(this.userService.changePassword(userId, newPassword));
  }

  resetPassword(id) {
    return catched(this.userService.resetPassword(id));
  }

  resetMyPassword() {
    return catched(this.userService.resetMyPassword());
  }

  search(email, role = "") {
    return catched(this.userService.search(email, role));
  }
}
